<template>
  <div>
    <template v-if="!isAdmin && is_approve_amenities != '1'">
      <b-alert show variant="warning">
        Amenities for this property are subject for approval.
      </b-alert>
    </template>
    <template v-else>
      <section class="d-flex justify-content-between my-2">
        <h4 class="text-decoration-none text-vb-primary">Amenity Details
        </h4>
        <div class="row align-items-center">
          <label class="font-weight-bold">Filter by Type:</label>
          <div class="d-flex align-items-center mx-2">
            <treeselect class="custom_filter" :options="options" placeholder="All Amenities" v-model="selectedNodes"
              :multiple="true" :value-format="'object'" style="max-width: 400px;" value-consists-of="BRANCH_PRIORITY" />

          </div>
          <div class="mr-2">
            <b-dropdown size="lg" variant="vb-tertiary" toggle-class="text-decoration-none" no-caret>
              <template #button-content>
                <font-awesome-icon :icon="['fas', 'filter']" /> Sort by: Level {{ levelAsc ? '(asc)' : '(desc)' }}
              </template>
              <b-dropdown-item @click="levelAsc = true" href="#"><font-awesome-icon
                  :icon="['fas', 'sort-numeric-down-alt']" /> Level
                (asc)</b-dropdown-item>
              <b-dropdown-item @click="levelAsc = false" href="#"><font-awesome-icon
                  :icon="['fas', 'sort-numeric-up-alt']" /> Level
                (desc)</b-dropdown-item>
            </b-dropdown>
          </div>
        </div>
      </section>
      <div class="text-right">
        <b-button v-if="isAdmin" :variant="approveButtonStyling.variant" @click="approveAmenities">{{
          approveButtonStyling.text }} <font-awesome-icon :icon="approveButtonStyling.icon" /></b-button>
        <b-button v-if="isAdmin" variant="vb-primary" v-b-modal.add-amenity-modal>Add <font-awesome-icon
            :icon="['fas', 'plus']" /></b-button>
      </div>
      <div v-for="(amenity_detail, am_d_index) in filteredAmenities" :key="am_d_index" class="mb-5">
        <div class="row justify-content-between align-items-center mt-3 px-3" style="background-color: #f5f5f5;">
          <div>
            <h4>{{ mapAmenityTitle(amenity_detail.all["field_select_amenity"]["und"]) }} <b-badge variant="vb-secondary"
                v-if="amenity_detail.amenity_level" pill>Level {{ amenity_detail.amenity_level }}</b-badge></h4>
            <h3 class="badge py-2 table-info" v-if="isRealValue(amenity_detail.amenity_area)">{{ amenity_detail.amenity_area }} sqft</h3>
          </div>
          <div v-if="isAdmin">
            <b-button variant="outline-vb-primary" class="border-0"
              @click="editAmenity(amenity_detail)"><font-awesome-icon :icon="['fas', 'pen']" /></b-button> |
            <b-button variant="outline-vb-red" class="border-0"
              @click="deleteAmenity(amenity_detail)"><font-awesome-icon :icon="['fas', 'times']" /></b-button>
          </div>
        </div>

        <div class="masonry-div mt-2 mb-30 border border-1 border-vb-accent masonry-div mt-10 p-3 rounded-lg"
          v-if="amenity_detail.amenity_files.length > 0">
          <div class="card-columns" style="cursor: pointer">
            <div v-for="(am_file, m_gallery_index) in amenity_detail.amenity_files" :key="m_gallery_index">
              <div class="card" @click="openAmenityModal(am_file)" v-if="am_file != null">
                <img :src="'https://www.realpropertydata.ca/backend/sites/default/files/' + am_file.filename"
                  class="card-img-top" alt="..." />
              </div>
            </div>

          </div>
        </div>
      </div>
    </template>
    <b-modal id="amenity_modal">
      <div v-if="fileAmenitySelected">
        <b-button class="float-right mb-3" variant="vb-red" v-if="isAdmin"
          @click="executeFileDeletion(fileAmenitySelected.fid)"><font-awesome-icon
            :icon="['fas', 'trash']" /></b-button>
        <img :src="'https://www.realpropertydata.ca/backend/sites/default/files/' + fileAmenitySelected.filename"
          class="card-img-top" alt="..." />
      </div>
    </b-modal>
    <b-modal id="add-amenity-modal" hide-footer @hidden="resetForm" :title="form.amenity_id ? 'Edit Amenity' : 'Add Amenity'">
      <div>
        <b-form @submit.prevent="onSubmit">
          <treeselect v-model="form.amenity" :multiple="true" :options="options" class="custom_filter"
            placeholder="Select your amenity type" flat :sort-value-by="'ORDER_SELECTED'" />
          <b-form-group id="input-group-1" label="Upload File:" label-for="input-1">
            <b-form-file v-model="form.files" placeholder="Place files here" :multiple="true"></b-form-file>
          </b-form-group>
          <b-form-group id="input-group-1" label="Size:" label-for="input-1">
            <b-form-input id="input-1" v-model="form.sqft" type="number" placeholder="Enter Sqft"></b-form-input>
          </b-form-group>
          <b-form-group id="input-group-1" label="Level:" label-for="input-1">
            <b-form-input id="input-1" v-model="form.level" type="number" placeholder="Enter Level"></b-form-input>
          </b-form-group>
          <b-button type="submit" variant="primary">Submit</b-button>
        </b-form>
      </div>
    </b-modal>
  </div>
</template>

<script>
import Treeselect from '@riophae/vue-treeselect'

import { BACKEND_URL } from '../variables';
import axios from 'axios';

// import the styles
import { LOAD_ROOT_OPTIONS } from '@riophae/vue-treeselect';
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import { useUserStore } from '../store/UserStore';
import { mapStores, mapState } from "pinia";
import { map } from 'jquery';
export default {
  components: {
    Treeselect
  },
  props: {
    amenityDetails: null,
    is_approve_amenities: null
  },
  data() {
    return {
      levelAsc: false,
      selectedNodes: [],
      fileAmenitySelected: null,
      form: {
        amenity: [],
        sqft: null,
        level: null,
        files: [],
        amenity_id: null
      },
      value: null,
      options: [],
    }
  },
  methods: {
    isRealValue(value) {
      return !['0', '', null,'null','-'].includes(value);
    },
    approveAmenities() {
      const vm = this;
      var approveValue = ['0', '', null].includes(this.is_approve_amenities) ? '1' : '0';
      const subText = approveValue == '1' ? 'This will also show the amenities for non-admin users' : 'This will hide the amenities for non-admin users';
      var formData = new FormData();
      formData.append('uid', this.$route.query.uid);
      formData.append('approve_amenities', approveValue);
      if (confirm(`${approveValue == '1' ? 'Approve' : 'Draft'} amenities for this property? ${subText}`)) {
        executeApprove(formData, approveValue);
      }
      function executeApprove(formData, approveValue) {
        axios.post(`${BACKEND_URL}api/amenity/approve`, formData)
          .then(result => {
            if (result.status == 200) {
              vm.makeToast('Success', `Amenities ${approveValue == '1' ? 'approved' : 'discarded'} successfully`, 'success');
              setTimeout(() => {
                vm.$emit('fetchData');
              }, 2000);
            }
          })
          .catch(error => {
            vm.makeToast('Error', `Failed to ${approveValue == '1' ? 'approve' : 'discard'} amenities`, 'danger');
          })
      }

    },
    mapAmenityTitle(amenity) {
      if (!amenity || !Array.isArray(amenity) || amenity.length === 0) return 'N/A';
      var mappedAmenities = amenity.map(a => a['tid']).map(tid => {
        let found = this.options.find(opt => opt.id == tid);
        if (found) return found.label;
        if (!found) {
          for (let opt of this.options) {
            if (opt.children) {
              let childFound = opt.children.find(child => child.id == tid);
              if (childFound) return childFound.label;
            }
          }
        }
      }).filter(label => label != null) || null;
      return mappedAmenities.join(', ');
      // if (mappedAmenities) {
      //   return mappedAmenities.sort((a, b) => a.localeCompare(b)).join(', ');
      // }
    },
    resetForm() {
      this.form = {
        amenity: null,
        sqft: null,
        level: null,
        files: [],
        amenity_id: null
      }
    },
    editAmenity(amenity) {
      this.form.amenity = amenity.all['field_select_amenity']['und']
        ? amenity.all['field_select_amenity'].und.map(a => Number(a.tid))
        : [];
      this.form.sqft = amenity.amenity_area
      this.form.level = amenity.amenity_level
      this.form.amenity_id = amenity.amenity_id
      this.$root.$emit('bv::show::modal', 'add-amenity-modal')
    },
    async deleteAmenity(amenity) {
      const vm = this;

      try {
        let fd = new FormData();
        fd.append("amenity_id", amenity.amenity_id);
        if (confirm(`Delete ${vm.mapAmenityTitle(amenity.all["field_select_amenity"]["und"])} ?`)) {
          alert(amenity.amenity_id)

          var result = await axios.post(`${BACKEND_URL}api/amenity/delete_amenity`, fd)
          if (result.status == 200) {
            this.makeToast('Success', 'Amenity deleted.', 'success');
            setTimeout(() => {
              this.$emit('fetchData');
            }, 2000);
          }
        }
      } catch (error) {
        this.makeToast('Error', 'Failed to delete amenity', 'danger');
      }

    },
    async fetchAmenityOptions() {
      var amenityOptions = await axios.get(`${BACKEND_URL}api/rest_test`)
      this.options = amenityOptions.data
    },
    openAmenityModal(file) {
      this.fileAmenitySelected = file
      this.$root.$emit('bv::show::modal', 'amenity_modal')

    },
    async onSubmit() {
      try {
        let formData = new FormData();
        if (this.form.amenity && this.form.amenity.length > 0) {
          this.form.amenity.forEach(tid => {
            formData.append('amenity[]', tid);
          });
        }
        formData.append('uid', this.$route.query.uid);
        formData.append('sqft', this.form.sqft);
        formData.append('level', this.form.level);
        formData.append('amenity_id', this.form.amenity_id);
        if (this.form.files) {
          this.form.files.forEach(file => {
            formData.append('files[]', file);
          })
        }
        var result = await axios.post(`${BACKEND_URL}api/amenity/add_update`, formData)
        if (result.status == 200) {
          this.makeToast('Success', 'Amenity details saved.', 'success');
          this.resetForm();
          setTimeout(() => {
            this.$emit('fetchData');
          }, 2000);
        }
      } catch (error) {
        this.makeToast('Error', 'Failed to submit form', 'danger');
      }

    },
    async executeFileDeletion(fileId) {
      if (!confirm('Delete this file?')) return;
      try {
        var formData = new FormData();
        formData.append('fid', fileId);

        await axios.post(`${BACKEND_URL}api/delete_file_by_fid`, formData);
        this.makeToast('Deleted', 'File removed successfully', 'success');
      } catch (error) {
        console.error("Delete File Error:", error);
        this.makeToast('Error', 'Failed to delete file', 'danger');
      }
    },
    makeToast(title, message, variant = 'success') {
      this.$bvToast.toast(message, {
        title: title,
        variant: variant,
        solid: true,
        autoHideDelay: 3000,
        appendToast: true,
        toaster: 'b-toaster-top-right'
      });
    },
  },
  computed: {
    ...mapState(useUserStore, ["current_user"]),
    approveButtonStyling() {
      if (this.is_approve_amenities == '1') {
        return { text: 'Draft', variant: 'outline-danger', icon: ['fas', 'eye-slash'] };
      } else {
        return { text: 'Approve', variant: 'vb-primary', icon: ['fas', 'thumbs-up'] };
      }
    },
    isAdmin() {
      return this.current_user && this.current_user.role && this.current_user.role.includes('admin');
    },
    isSuperAdmin() {
      return [
        "mark.wang+urban@devradius.com",
        "darcysrai@gmail.com",
      ].includes(this.current_user.mail);
    },
    filteredAmenities: {
      get: function () {
        let result = this.amenityDetails ? [...this.amenityDetails] : [];

        if (this.selectedNodes && this.selectedNodes.length > 0) {
          const allAllowedLabels = new Set();
          const getLabelsRecursive = (node) => {
            allAllowedLabels.add(node.label);
            if (node.children && node.children.length > 0) {
              node.children.forEach(child => getLabelsRecursive(child));
            }
          };

          this.selectedNodes.forEach(node => getLabelsRecursive(node));

          result = result.filter(item =>
            allAllowedLabels.has(item.amenity_title)
          );
        }

        result.sort((a, b) => {
          const valA = parseFloat(a.amenity_level) || 0;
          const valB = parseFloat(b.amenity_level) || 0;

          if (this.levelAsc) {
            return valA - valB;
          } else {
            return valB - valA;
          }
        });

        return result;
      },
      set: function (newValue) {
        return newValue;
      }
    }
  },
  created() {
    this.fetchAmenityOptions()
  }
}
</script>

<style lang="scss" scoped>
.form-group label {
  font-size: 1.5rem;
}
</style>
